var assign = require("lodash/assign");

export function QueryString(query) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (!query) {
    return;
  }

  return {
    "query_string": assign({
      query: query
    }, options)
  };
}